import React from "react";
import type { FC, PropsWithChildren } from "react";
import AdAdminSidebar from "./AdAdmin";

import AdminSidebar from "./AdminSidebar";
import AdUserSidebar from "./AdUserSidebar";
import ClinicManageSidebar from "./ClinicManageSidebar";
import FileAdminSidebar from "./FileAdminSidebar";
import FileUserSidebar from "./FileUserSidebar";
import ClinicSidebar from "./ClinicSidebar";
import ClinicianSidebar from "./ClinicianSideBar";
import RTMAdminSidebar from "./RTMAdminSidebar";
import "../../styles/SideBar.css";
import EeceptionistSidebar from "./ReceptionistSidebar";
import RTMProviderSidebar from "./RTMProviderSidebar";

export type SideProps = PropsWithChildren<{
  currentMenu:
    | "dashboard"
    | "clinics"
    | "Associate-clinics"
    | "users"
    | "RTM"
    | "rtm-time-logging"
    | "secure-files"
    | "ad-campaigns"
    | "view-campaign"
    | "my-profile"
    | "questions"
    | "providers"
    | "patients"
    | "appointment"
    | "documents"
    | "check-in"
    | "feedback"
    | "patient-feedback"
    | "admin-dashboard"
    | "resource"
    | "rtm-template"
    | "rtm-resource"
    | "rtm-plan"
    | "patient"
    | "chat"
    | "PatientsDashboard"
    | "plan-patient-list"
    | "BillingList";
}>;

type SideBarProps = PropsWithChildren<{
  currentMenu: SideProps["currentMenu"];
  userRole: string;
}>;

const Sidebar: FC<SideBarProps> = ({ currentMenu, userRole }) => {
  return (
    <React.Fragment>
      {userRole === "admin" ? (
        <AdminSidebar currentMenu={currentMenu} />
      ) : userRole === "adAdmin" ? (
        <AdAdminSidebar currentMenu={currentMenu} />
      ) : userRole === "adUser" ? (
        <AdUserSidebar currentMenu={currentMenu} />
      ) : userRole === "fileAdmin" ? (
        <FileAdminSidebar currentMenu={currentMenu} />
      ) : userRole === "clinic" ? (
        <ClinicSidebar currentMenu={currentMenu} />
      ) : userRole === "manager" ? (
        <ClinicManageSidebar currentMenu={currentMenu} />
      ) : userRole === "clinician" ? (
        <ClinicianSidebar currentMenu={currentMenu} />
      ) : userRole === "receptionist" ? (
        <EeceptionistSidebar currentMenu={currentMenu} />
      ) : userRole === "rtmAdmin" ? (
        <RTMAdminSidebar currentMenu={currentMenu} />
      ) : userRole === "rtmProvider" ? (
        <RTMProviderSidebar currentMenu={currentMenu} />
      ) : userRole === "rtmManager" ? (
        <RTMProviderSidebar currentMenu={currentMenu} />
      ) : (
        <FileUserSidebar currentMenu={currentMenu} />
      )}
    </React.Fragment>
  );
};

export default Sidebar;
